/**
 * Words a booking message carries (sharedText.ts), kept apart so the note can tell cheaply whether its text may be one before Unpack's
 * code is loaded. Only a hint: Unpack decides.
 */
export const BOOKING_WORDS = /\b(?:booked|booking|reservation|reserved|table for|confirmed|confirmation|check-?in|tickets?|boarding|e-?ticket|appointment|order number|buchung|reservierung|réservation|reserva|prenotazione)\b/i

export const mayBeBookingShare = (text: string) => text.length > 0 && text.length <= 3000 && BOOKING_WORDS.test(text)
